import style from "../style/mininput.module.css";
import { maskMoney } from "../function/funcionalidades";

export default function MinInput({
  mask,
  inputMask,
  placeholder,
  valor,
  width,
}) {
  function handleMask(text) {
    if (mask === "currency") {
      inputMask(maskMoney(text));
    } else {
      inputMask(text);
    }
  }

  function handleStyle() {
    if (width == 478) {
      return {
        border: "0.6px solid #abaaaa",
        height: "46px",
        width: "478px",
        backgroundColor: "#BDE2ED",
        borderRadius: "9px",
        outline: "none",
        fontFamily: "Raleway",
      };
    } else {
      return {
        border: "0.6px solid #abaaaa",
        height: "46px",
        width: "500px",
        backgroundColor: "#BDE2ED",
        borderRadius: "9px",
        outline: "none",
        fontFamily: "Raleway",
      };
    }
  }
  return (
    <input
      type="text"
      placeholder={placeholder}
      value={valor}
      onChange={(e) => handleMask(e.target.value)}
      className={style.input}
    />
  );
}
